import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { http, fmt } from "@/lib/api";
import { VideoCard } from "@/components/VideoCard";
import { YT } from "@/constants/testIds";

export default function Home() {
  const [params, setParams] = useSearchParams();
  const sort = params.get("sort") || "recent";
  const [videos, setVideos] = useState([]);
  const [channel, setChannel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    Promise.all([
      http.get(`/videos`, { params: { sort } }),
      http.get(`/channel`).catch(() => ({ data: null })),
    ])
      .then(([v, c]) => {
        if (!alive) return;
        setVideos(v.data || []);
        setChannel(c?.data || null);
        setError(null);
      })
      .catch((e) => alive && setError(e?.message || "failed to load"))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [sort]);

  const featured = videos[0];
  const rest = videos.slice(1);

  return (
    <div data-testid={YT.homePage}>
      {/* Channel strip */}
      {channel ? (
        <div className="yt-section">
          <div className="yt-section-title">Featured Channel</div>
          <div
            className="yt-section-body"
            style={{ display: "flex", gap: 12, alignItems: "center" }}
          >
            {channel.avatar ? (
              <img
                src={channel.avatar}
                alt={channel.name}
                width={64}
                height={64}
                style={{ border: "1px solid #888" }}
              />
            ) : null}
            <div>
              <Link
                to="/channel"
                style={{ fontWeight: "bold", fontSize: 14 }}
              >
                {channel.name}
              </Link>
              <div style={{ color: "#555", marginTop: 2 }}>
                @{channel.handle} &middot;{" "}
                <b>{channel.subscribers_label}</b> subscribers &middot;{" "}
                <b>{fmt.views(channel.total_views)}</b> total views
              </div>
            </div>
            <button
              className="yt-btn yt-btn-red"
              style={{ marginLeft: "auto" }}
              data-testid={YT.subscribeBtn}
            >
              Subscribe
            </button>
          </div>
        </div>
      ) : null}

      {/* Featured video */}
      {featured ? (
        <div className="yt-section">
          <div className="yt-section-title">Featured Video</div>
          <div
            className="yt-section-body"
            style={{ display: "grid", gridTemplateColumns: "260px 1fr", gap: 14 }}
          >
            <Link to={`/watch/${featured.video_id}`} className="yt-thumb-wrap">
              <img src={featured.thumbnail} alt={featured.title} />
              {featured.is_short ? (
                <span className="yt-thumb-short">SHORT</span>
              ) : null}
            </Link>
            <div>
              <Link
                to={`/watch/${featured.video_id}`}
                style={{ fontSize: 16, fontWeight: "bold" }}
              >
                {featured.title}
              </Link>
              <div className="yt-meta" style={{ marginTop: 6 }}>
                Added: {fmt.ago(featured.published)}
                <br />
                Views: <b>{fmt.views(featured.views)}</b>
                <br />
                From: <Link to="/channel">John Casterline</Link>
              </div>
              <p
                style={{
                  marginTop: 8,
                  color: "#333",
                  fontSize: 12,
                  lineHeight: 1.45,
                }}
              >
                Watch the latest upload from <b>@h1t1</b>. Click the thumbnail
                to play. Rate the video with the 5-star widget and drop a
                comment like it's 2008.
              </p>
            </div>
          </div>
        </div>
      ) : null}

      {/* Sort tabs */}
      <div className="yt-section">
        <div
          className="yt-section-title"
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          <span>Videos</span>
          <span style={{ marginLeft: "auto", fontWeight: "normal" }}>
            Sort by:{" "}
            <select
              value={sort}
              onChange={(e) =>
                setParams(
                  e.target.value === "recent"
                    ? {}
                    : { sort: e.target.value }
                )
              }
              data-testid={YT.sortSelect}
              style={{ fontSize: 11 }}
            >
              <option value="recent">Most Recent</option>
              <option value="popular">Most Viewed</option>
              <option value="top">Top Rated</option>
            </select>
          </span>
        </div>
        <div className="yt-section-body">
          {loading ? (
            <div style={{ padding: 20, color: "#555" }}>Loading videos…</div>
          ) : error ? (
            <div style={{ padding: 20, color: "#c00" }}>Error: {error}</div>
          ) : (
            <div className="yt-grid" data-testid={YT.videoGrid}>
              {rest.map((v) => (
                <VideoCard key={v.video_id} video={v} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
